import { render } from "./mvt-inputdecimalnumber.vue?vue&type=template&id=017854ba"
import script from "./mvt-inputdecimalnumber.vue?vue&type=script&lang=js"
export * from "./mvt-inputdecimalnumber.vue?vue&type=script&lang=js"

import exportComponent from "/builds/movoto/frontend/consumer-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__